export enum PowerplatformCopilotAuthenticationTypeEnum {
    noAuthentication = "noAuthentication",
    permittedUsersOnly = "permittedUsersOnly",
    signinRequiredCustomWebsite = "signinRequiredCustomWebsite",
}
